import {useState } from "react";
import { MenuItem, Tooltip, IconButton,Menu,} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Offcanvas } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import { useForm } from "react-hook-form";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import CommonDeleteDialog from "../../common/CommonDelete";
import { useParams } from "react-router-dom";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import { CommonAddTaskTab } from "../../common/Task/CommonAddTaskTab";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { usePersistentFilter } from "../../../assets/hooks/usePersistentFilter";
import SubtaskBoard from "../task/SubtaskBoard";
import { useTheme } from "../../../ThemeContext";
import Loader from "../../common/Loader";


// const MilestoneTaskListSubtask = ({ refetchCount }) => {
//   const [MilestonesubTask, setMilestonesubTask] = useState();
const MilestoneTaskListSubtask = ({ MilestonesubTask, fetchMilestonesubtask }) => {
  const { isDarkMode } = useTheme();
  const [viewMode, setViewMode] = usePersistentFilter("milestoneSubtaskDetailViewMode", "list");
  
  const [showProject, setShowProject] = useState(false);
  // const handleShowProject = () => setShowProject(true); // Open filter
  const [editData, setEditData] = useState(null);
  const handleShowProject = () => {
    setEditData(null);
    setShowProject(!showProject);
  };
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  const handleEditSubtask = (event) => {
    event.stopPropagation();
    setEditData(selectedRow);
    setShowProject(true);
    handleMenuClose();
  };

  const { reset } = useForm();
  const { id } = useParams();
  const [paginationModel, setPaginationModel] = useState({
    page: 1,
    pageSize: 10,
  });

  // const taskId = useSelector((state) => state.selectOptions.taskId);
  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 100,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
          <IconButton
            onClick={(e) => handleMenuClick(e, params.row)}
            size="small"
            style={{ padding: "10px", marginBottom:"10px" }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </div>
      ),
    },
    { field: "id", headerName: "ID", width: 150 },
    { field: "title", headerName: "Task", width: 200 },
    {
      field: "owner_name",
      headerName: "Owner",
      width: 150,
      renderCell: (params) => {
        const owners = params.row.owners || [];
        const displayValue = owners.length > 0
          ? `${owners[0].name}${owners.length > 1 ? ` (+${owners.length - 1})` : ""}`
          : (params.row.owner || params.row.owner_name || "Unassigned");
        
        const tooltipTitle = owners.length > 0 ? (
          <Box>
            {owners.map((o, index) => (
              <div key={index}>{o.name}</div>
            ))}
          </Box>
        ) : displayValue;

        return (
          <Tooltip title={tooltipTitle} arrow>
            <Box sx={{ cursor: "pointer" }}>{displayValue}</Box>
            </Tooltip>
        );
      },
    },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        const color = params.row.status_colour;
        //console.log()("color", color);
        const name = params.value;
        return <p style={{ color: color || "black" }}>{name}</p>;                                      
      },
    },
    { field: "start_date", headerName: "Start Date", width: 150 },
    { field: "end_date", headerName: "Due Date", width: 150 },
    { field: "estimated_hours", headerName: "Duration", width: 150 },
    {
      field: "priority_name",
      headerName: "Priority",
      width: 150,
      renderCell: (params) => {
        const color = params.row.priority_colour;
        //console.log()("color", color);
        const name = params.value;
        return <p style={{ color: color || "black" }}>{name}</p>;
      },
    },

    { field: "creater_name", headerName: "Created By", width: 150 },
    {
      field: "added_at",
      headerName: "Created At",
      width: 150,
      renderCell: (params) => {
        return (
          <p>
            {params.value ? dayjs(params.value).format("YYYY-MM-DD") : "N/A"}
          </p>
        );
      },
    },
    { field: "completed_percentage", headerName: "Completed", width: 150 },
    { field: "consumed_hours", headerName: "work hours", width: 150 },
  ];

  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log()("login_user_detail in redux state: ", loginUser);
  const { role: login_user_role } = loginUser;
  // const fetchMilestonesubtask = async () => {
  //   try {
  //     const response = await fetchEntityById("milestones/task/subtask", id);

  //     //console.log()(response, "fetchMilestonesubtask");
  //     if (response?.subtasks?.length > 0) {
  //       const data = response.subtasks;
  //       // const data = response.issues.map((issue) => ({
  //       //   ...issue,
  //       //   id: issue.issue_id, // Add id field for Data Grid
  //       // }));
  //       //console.log()(data, "Mapped Issues Data");
  //       setMilestonesubTask(data);
  //     } else {
  //       console.error("No issues found in the response.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching issues:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchMilestonesubtask();
  // }, [id]);
  //console.log()("milestone_subtask", MilestonesubTask);

  return (
    <>
      <Offcanvas
        show={showProject}
        onHide={() => {
          setShowProject(false);
          setEditData(null);
        }}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          
          <CommonAddTaskTab
            // onCancel={handleCloseProject}
            // // ProjectID={ProjectID}
            // refetchList={fetchTaskModule}
            // isModule={true}
            // path_1="task"
            // path_2="add"
            onClear={() => reset()} // Resets to initial values
            onCancel={() => {
              setShowProject(false);
              setEditData(null);
            }}
            refetchList={fetchMilestonesubtask}
            path_1="milestones/task/subtask"
            path_2="add"
            isSubtaskList={true}
            editData={editData}
            // onApply={handleShowProject}
            // onCancel={() => setShowProject(false)}
            // refetchList={fetchSubtasks}
            // onClear={() => reset()}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem onClick={handleEditSubtask}>
          <CiEdit className="me-2" color="blue" />
          Edit Task
        </MenuItem>

        <CommonDeleteDialog
          name="Subtask"
          refetchList={fetchMilestonesubtask}
          handleListClose={handleMenuClose}
          url="task/delete"
          id={selectedRow?.id || selectedRow?.task_id}
          statusName={selectedRow?.title}
          logHours={selectedRow?.log_hours}
        />
      </Menu>

      <Box
        className="d-flex justify-content-between align-items-center"
        sx={{
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          borderRadius: "6px",
          padding: "12px 16px",
          marginBottom: "12px",
          backgroundColor: isDarkMode ? "transparent" : "#fff",
          marginTop: "10px"
        }}
      >

        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <Tooltip title="Table View">
            <IconButton
              onClick={() => setViewMode("list")}
              sx={{
                backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                borderRadius: "4px",
                height: "32px",
                width: "75px",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <CiViewList size={18} />
              Table
            </IconButton>
          </Tooltip>
          
          <Tooltip title="Board View">
            <IconButton
              onClick={() => setViewMode("board")}
              sx={{
                backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                borderRadius: "4px",
                height: "32px",
                width: "75px",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <MdViewQuilt size={18} />
              Board
            </IconButton>
          </Tooltip>
        </div>
        
        {login_user_role !== "CLIENT" && (
          <button className="add_btn" onClick={handleShowProject}>
            Add Subtask
          </button>
        )}
      </Box>

      <div style={{ width: "100%" }}>
        {loading ? (
          <Loader />
        ) : (
          <Box sx={{ height: (MilestonesubTask === undefined || MilestonesubTask.length === 0) ? 300 : "auto" }}>
            <div className="h-auto">
              {viewMode === "list" ? (
                <DataGrid
                  rows={MilestonesubTask || []}
                  columns={columns}
                  pageSizeOptions={[10, 20, 30, 40]}
                  pagination
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                  getRowId={(row) => row.id || row.task_id}
                />
              ) : (
                <SubtaskBoard
                  numericId={id}
                  allTasks={(MilestonesubTask || []).map(t => ({
                    ...t,
                    id: t.id || t.task_id
                  }))}
                  onRefresh={fetchMilestonesubtask}
                  loading={loading}
                  onOpenTask={(task) => {
                    setEditData(task);
                    setShowProject(true);
                  }}
                />
              )}
            </div>
          </Box>
        )}
      </div>


    </>
  );
};

export default MilestoneTaskListSubtask;
